import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "tick",
  "use": "tick-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tick\"><path d=\"M3.707 13.293a1 1 0 0 0-1.414 1.414l1.414-1.414zm18-4.586a1 1 0 0 0-1.414-1.414l1.414 1.414zM3 14l-.707.707v.001l.004.003.01.01.042.042.16.16.573.573 1.773 1.774 2.938 2.937 1.414-1.414-2.937-2.938-1.774-1.773-.573-.573-.16-.16-.042-.042a1.946 1.946 0 0 0-.01-.01l-.003-.003v-.001L3 14zm4.793 6.207c.108.108.247.25.38.355.125.101.414.313.827.313s.702-.212.828-.313c.132-.105.271-.247.38-.355l-1.415-1.414a11.843 11.843 0 0 1-.215.207c-.006.005.028-.023.092-.053a.781.781 0 0 1 .33-.072c.144 0 .258.038.33.072.064.03.098.058.092.053a11.843 11.843 0 0 1-.214-.207l-1.415 1.414zm2.414 0l5.938-5.937 3.835-3.836 1.253-1.253a895.12 895.12 0 0 0 .442-.442l.024-.024a.394.394 0 0 0 .008-.007L21 8l-.707-.707-.002.002a.448.448 0 0 1-.03.03 88.688 88.688 0 0 1-.442.442l-1.253 1.252-3.836 3.836-5.937 5.938 1.414 1.414z\" fill=\"#702F73\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/tick.svg
// module id = 164
// module chunks = 0